import axios from "axios";

// Setup global de axios para que las requests al proxy de Next lleven la
// cookie httpOnly automáticamente, y para limpiar `Authorization: Bearer `
// cuando el token está vacío (caso customer post-migración: el token vive en
// la cookie y los services legacy aún hardcodean el header).

let configured = false;

export const setupAxios = () => {
  if (configured) return;
  configured = true;

  axios.interceptors.request.use((config) => {
    const url = config.url || "";
    const goesToNext = url.includes("/api/proxy/") || url.includes("/api/auth/");

    // Cuando hablamos con Next (proxy o auth), mandamos cookies. Sin esto, el
    // proxy no puede leer propi_session y responde 401.
    if (goesToNext) {
      config.withCredentials = true;
    }

    // Si los services pasaron `Authorization: Bearer ` con token vacío
    // (porque user.token es '' en el flujo de cookies), removemos el header
    // para que Next pueda extraer el token desde la cookie.
    const headers = config.headers as any;
    if (headers) {
      const auth = headers["Authorization"] ?? headers["authorization"];
      if (typeof auth === "string" && auth.trim().toLowerCase() === "bearer") {
        delete headers["Authorization"];
        delete headers["authorization"];
      }
    }

    return config;
  });
};
